import * as Yup from 'yup';
import moment from 'moment';
import { LoginResponseData } from '@EHSNavigator/backend';

export const getChangeUserRoleSchema = ({
  userInfo,
}: {
  userInfo: LoginResponseData | null;
}) => {
  const isOwner = userInfo?.user?.role?.name === 'Owner';

  return Yup.object().shape({
    employeeId: isOwner
      ? Yup.string()
      : Yup.string().required('Employee Id is required'),

    fullName: Yup.string().required('Full Name is required'),

    departmentId: isOwner
      ? Yup.string()
      : Yup.string().required('Department is required'),

    roleId: isOwner
      ? Yup.string()
      : Yup.string().required('Role is required'),

    jobTitle: isOwner
      ? Yup.string()
      : Yup.string().required('Job Title is required'),

    contact: Yup.string()
      .required('Contact is required')
      .matches(
        /^\+?[0-9\s\-()]{7,20}$/,
        'Contact must be a valid phone number',
      ),

    dob: Yup.date()
      .nullable()
      .max(moment().toDate(), 'Date of Birth cannot be in the future'),

    dateOfHire: Yup.date()
      .required('Date of Hire is required')
      .test(
        'is-after-dob',
        'Date of Hire must be after Date of Birth',
        function (value) {
          const { dob } = this.parent;
          if (!dob) return true;

          const dobDate = moment(dob);
          if (!dobDate.isValid()) return true;

          const hireDate = moment(value);
          if (!hireDate.isValid()) return false;

          return hireDate.isAfter(dobDate);
        },
      ),
  });
};


export const getDeleteUserSchema = (name: string) => {
  return Yup.object().shape({
    name: Yup.string()
      .oneOf(
        [`${name.trim().replace(/\s+/g, ' ')}`],
        `You must type "${name.trim().replace(/\s+/g, ' ')}" exactly`,
      )
      .required(`You must type "${name.trim().replace(/\s+/g, ' ')}" exactly`),
  });
};
